import { PROMPT_MAX_LENGTH } from "../../shared/prompts.js";

export type PromptInputProps = {
  id: string;
  label: string;
  value: string;
  placeholder: string;
  disabled?: boolean;
  onChange: (value: string) => void;
};

export function PromptInput({
  id,
  label,
  value,
  placeholder,
  disabled = false,
  onChange,
}: PromptInputProps) {
  const counterId = `${id}-counter`;
  const nearLimit = value.length >= PROMPT_MAX_LENGTH * 0.9;

  return (
    <div className="prompt-input-group">
      <label className="prompt-input-label" htmlFor={id}>
        {label}
      </label>
      <textarea
        id={id}
        className="prompt"
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={PROMPT_MAX_LENGTH}
        aria-describedby={counterId}
        onChange={(event) => onChange(event.target.value)}
      />
      <div className="prompt-input-controls">
        <output
          id={counterId}
          htmlFor={id}
          className={nearLimit ? "prompt-count prompt-count-near-limit" : "prompt-count"}
        >
          {value.length.toLocaleString()} / {PROMPT_MAX_LENGTH.toLocaleString()} characters
        </output>
        <button
          type="button"
          className="btn ghost btn-compact"
          disabled={disabled || value.length === 0}
          onClick={() => onChange("")}
        >
          Clear
        </button>
      </div>
    </div>
  );
}
